import React from 'react'
import { Container } from 'react-bootstrap'
import "./galery.styles.css"
import Carousel from 'react-multi-carousel'
import Gallery1 from "../../assets/Triton entrance.jpg"
import Gallery2 from "../../assets/Triton room.jpg"
import Gallery3 from "../../assets/Triton waiting room.jpg"
import WA from "../../assets/wa.svg"
import Map from "../../components/map/map"


const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 450 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 450, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
}


export default function Gallery() {
  return (
    <>
      <div className="feedback-container">
        <text className="feedback-heading">
          <span style={{ color: "#575B67" }}>Gallery</span>
        </text>
        <div className="feedback-carousel-container">
          <Carousel responsive={responsive} className="carousel-container">
            <div className="carousel-card">
              <img src={Gallery1} style={{ maxHeight: "100%", maxWidth: "100%" }} alt="Gallery1" />
            </div>
            <div className="carousel-card">
              <img src={Gallery2} style={{ maxHeight: "100%", maxWidth: "100%" }} alt="Gallery2" />
            </div>
            <div className="carousel-card">
              <img src={Gallery3} style={{ maxHeight: "100%", maxWidth: "100%" }} alt="Gallery3" />
            </div>
          </Carousel>
        </div>
      </div>
      <div className="gallery-container">
        <Container>
          {/* <div className="gallery-box">
          <Row>
            <text className="gallery-heading">Gallery</text>
          </Row>
          <div className="gallery-image-container">
            <Row >
              <Col md={4} className="gallery-image-div"><img src={Gallery1} alt="Gallery1" className="gallery-image" /></Col>
              <Col md={4} className="gallery-image-div"><img src={Gallery2} alt="Gallery1" className="gallery-image" /></Col>
              <Col md={4} className="gallery-image-div"><img src={Gallery3} alt="Gallery1" className="gallery-image" /></Col>
            </Row>
          </div>
        </div> */}
          <div className="clinic-loaction-container">
            <div className="clinic-loaction-header">Clinic <span className="gallery-heading">Location</span></div>
            <div className="map-container"><Map /></div>
          </div>
          <div className="book-now-wa">
            <div><button className="book-now-btn" onClick={() => { window.open("https://api.whatsapp.com/send/?phone=918707699762&text=9999202000%20press%20send%20to%20book%20appointment%20with%20Dr.%20Aashima%20%F0%9F%91%89") }}><img src={WA} alt="WA" style={{ marginRight: "0.7rem" }} />Book Now</button></div>
            <div className="book-now-subtext">Book an appointment now using WhatsApp</div>
          </div>
        </Container>
      </div>
    </>
  )
}
